'use client'

import { Carousel } from "nuka-carousel";
import Image from "next/image";
import { ImageData } from "./ImageData";

export default function ImageCarousel({sourceArray} : {
  sourceArray: ImageData[]
}) {
  return (
  <>
    <Carousel 
      showArrows 
      wrapMode="wrap"
      className={``}
      scrollDistance="slide"
      autoplay
      autoplayInterval={6000}
    >
      {sourceArray.map((imageItem) => (
        <Image
          key={imageItem.id}
          src={imageItem.src}
          width={700}
          height={100}
          className={
            `
            shrink-0
            rounded-[2rem]
            `
          }
          alt=""
        />
      ))}
    </Carousel>
  </>
  )
}